import { ExclamationCircleIcon } from '@heroicons/react/24/outline';

import { useTranslation } from 'react-i18next';
import { Heading } from '@restworld/ui-ds-base';
import { Button } from '@restworld/ui-ds-base';

/* eslint-disable-next-line */
export interface ExitConfirmationProps {
  onExitApplication: () => void;
  onCancel: () => void;
}

export function ExitConfirmation({ onExitApplication, onCancel }: ExitConfirmationProps) {
  const { t } = useTranslation('onboarding-page');
  return (
    <div className="flex flex-col gap-6 pb-2">
      <div className="flex flex-col gap-4 items-center">
        <ExclamationCircleIcon className="w-8 h-8 text-red-800" />
        <div className="flex gap-2 flex-col max-w-sm items-center text-center">
          <Heading size={3} weight="semibold" className="leading-9">
            {t('do_you_want_to_exit_spontaneous_application')}
          </Heading>
          <Heading size={5} weight="normal" color="muted" className="leading-6">
            {t('if_you_exit_progress_will_not_be_saved')}
          </Heading>
        </div>
      </div>
      <div className="flex flex-col gap-4">
        <Button variant="primary" fullwidth onClick={onExitApplication}>
          {t('yes_exit_application')}
        </Button>
        <Button variant="secondary-neutral" fullwidth onClick={onCancel}>
          {t('cancel')}
        </Button>
      </div>
    </div>
  );
}

export default ExitConfirmation;
